import "./styles/RightBarStyle.css";
import PlaceAiPanel from "./PlaceAiPanel";

const RightBar = ({
  rightBarOpen,
  setRightBarOpen,
  spi_legend_url,
  Legend,
  precipitation_check,
  fapar_anomaly_check,
  fapar_anomaly_legend_url,
  fapar_absorbed_check,
  fapar_absorbed_legend_url,
  monthly_precipitation_check,
  gpcc_monthly_precipitation_legend_url,
  sma_check,
  legend_url_sma,
  cdi_check,
  ndvi_check,
  koppen_climate_clas_check,
  koppen_climate_url,
  setActive_tab,
  active_tab,
  cdi_selected_dates,
  clicked_latlong,
  pixelDataFetched,
  setAdmin_details,
  setShow_generate_report,
  unwdc_check,
  checked_spi_era5,
  cdi_era5_check,
  longrange_forecast_check,
  drought_persistence_check,
  combined_hazard_era5_check,
  combined_hazard_gpcc_check,
  combined_forecast_era5_check,
  combined_forecast_gpcc_check,
  layerOpacity,
  onOpacityChange,
}) => {
  

  const getContent = () => {
    switch (active_tab) {
      case "Legend":
        return (
          <>
          {precipitation_check || fapar_anomaly_check || fapar_absorbed_check || monthly_precipitation_check || sma_check
           || cdi_check || ndvi_check || koppen_climate_clas_check || unwdc_check ||checked_spi_era5 || cdi_era5_check || longrange_forecast_check
           || drought_persistence_check || combined_hazard_era5_check || combined_hazard_gpcc_check
           || combined_forecast_era5_check || combined_forecast_gpcc_check
           ?  (<Legend
            spi_legend_url={spi_legend_url}
            precipitation_check={precipitation_check}
            fapar_anomaly_check={fapar_anomaly_check}
            fapar_anomaly_legend_url={fapar_anomaly_legend_url}
            fapar_absorbed_check={fapar_absorbed_check}
            fapar_absorbed_legend_url={fapar_absorbed_legend_url}
            monthly_precipitation_check={monthly_precipitation_check}
            gpcc_monthly_precipitation_legend_url={
              gpcc_monthly_precipitation_legend_url
            }
            sma_check={sma_check}
            legend_url_sma={legend_url_sma}
            cdi_check={cdi_check}
            ndvi_check={ndvi_check}
            koppen_climate_clas_check={koppen_climate_clas_check}
            koppen_climate_url={koppen_climate_url}
            unwdc_check={unwdc_check}
            checked_spi_era5={checked_spi_era5}
            cdi_era5_check={cdi_era5_check}
            longrange_forecast_check={longrange_forecast_check}
            drought_persistence_check={drought_persistence_check}
            combined_hazard_era5_check={combined_hazard_era5_check}
            combined_hazard_gpcc_check={combined_hazard_gpcc_check}
            combined_forecast_era5_check={combined_forecast_era5_check}
            combined_forecast_gpcc_check={combined_forecast_gpcc_check}
          layerOpacity={layerOpacity}
            onOpacityChange={onOpacityChange}
          />) : <div className="content is-normal has-text-centered m-1">
          <h5></h5>
        <p className="is-size-6 is-family-code"> No Layers selected</p>
        </div>}
          </>
        );
      default:
        return null;
    }
  };

  return (
    <div className={`RightBarContainer${rightBarOpen ? "" : " rightbar-collapsed"}`}>
      <div id="tabContainer">
        <button
          className="rightbar-toggle-btn"
          onClick={() => setRightBarOpen((v) => !v)}
          aria-label={rightBarOpen ? "Collapse panel" : "Expand panel"}
          title={rightBarOpen ? "Collapse" : "Expand"}
        >
          {rightBarOpen ? "\u25B6" : "\u25C0"}
        </button>
        {rightBarOpen && (
          <>
            <div
              onClick={() => setActive_tab("Legend")}
              style={{
                cursor: "pointer",
                backgroundColor: active_tab === "Legend" ? "lightgray" : "",
              }}
            >
              LEGEND
            </div>
            <div
              onClick={() => setActive_tab("Analysis")}
              style={{
                cursor: "pointer",
                backgroundColor: active_tab === "Analysis" ? "lightgray" : "",
              }}
            >
              ANALYSIS
            </div>
          </>
        )}
      </div>
      {rightBarOpen && (
        <div id="contentContainer">
          {/* Legend tab — conditionally rendered (no heavy state to preserve) */}
          <div style={{ display: active_tab === "Legend" ? "" : "none" }}>
            {getContent()}
          </div>

          {/* Analysis tab — always mounted so AI response is not lost on tab switch */}
          <div style={{ display: active_tab === "Analysis" ? "" : "none" }}>
            <PlaceAiPanel
              dates={cdi_selected_dates}
              clicked_latlong={clicked_latlong}
              setAdmin_details={setAdmin_details}
              setShow_generate_report={setShow_generate_report}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default RightBar;
